import React from 'react'
import { Switch, Route } from 'react-router-dom'

import DynamicModuleLoaderComponent from '../sharedLegacy/components/DynamicModuleLoaderComponent/DynamicModuleLoaderComponent'
import webinarModule from '../Webinar'
import { WebinarIndexComponent } from '../Webinar/components'

const modules = [webinarModule]

const WebinarProducerRoutesComponent = () => {
  return (
    <DynamicModuleLoaderComponent modules={modules}>
      <Switch>
        <Route path="/webinar" component={WebinarIndexComponent} />
      </Switch>
    </DynamicModuleLoaderComponent>
  )
}

export default WebinarProducerRoutesComponent
